import { useEffect, useRef } from "react";

const INACTIVITY_MS = 2 * 60 * 1000; // 2 minutes

export function useInactivityLogout({ enabled, onLogout }) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onLogout();
      }, INACTIVITY_MS);
    };

    const events = ["mousedown", "mousemove", "keydown", "touchstart", "scroll", "click"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [enabled, onLogout]);
}
